<template>
  <Toggle :aria-label="$t('common.toggleTheme')" @click="toggleColorMode">
    <ClientOnly>
      <Icon
        v-if="colorMode.preference === 'dark'"
        name="lucide:moon"
        class="h-5 w-5"
      />
      <Icon
        v-else-if="colorMode.preference === 'light'"
        name="lucide:sun"
        class="h-5 w-5"
      />
      <Icon v-else name="lucide:monitor-cog" class="h-5 w-5" />
    </ClientOnly>
  </Toggle>
</template>

<script setup>
const colorMode = useColorMode();

const toggleColorMode = () => {
  if (colorMode.preference === "light") {
    colorMode.preference = "dark";
  } else if (colorMode.preference === "dark") {
    colorMode.preference = "system";
  } else {
    colorMode.preference = "light";
  }
};
</script>
